import { CollapseListItem } from 'types/commons';

const list: CollapseListItem[] = [
  {
    key: '1',
    label: 'Employer Benefits',
    className: 'Employer',
    content: (
      <>
        <label>Direct connections</label>
        <p>
          To workers they need through access to a global network of talent,
          refugees and New Americans who are already skilled.
        </p>

        <label>Thorough pre-screening</label>
        <p>
          Job applicants come vetted by a rapid and efficient recruitment
          process, which includes a translator provided to alleviate any
          language barriers.
        </p>

        <label>Background and identity pre-verification</label>
        <p>
          By Joblio to help employers simplify the collection of data for
          onboarding and work permit/visa processing.
        </p>

        <label>Continuous support</label>
        <p>
          Cross-cultural training facilitated by Joblio for the entire term of
          employment via its Applicant Concierge Experience (ACE) program, which
          creates success, loyalty and retention of talent who may otherwise
          quit.
        </p>

        <label>Organizational reputation boost</label>
        <p>
          For a visible commitment to ethical recruitment, corporate
          responsibility and DEI (diversity, equity and inclusion) – which can
          lead to word-of-mouth referrals of other qualified job seekers.
        </p>
      </>
    )
  },
  {
    key: '2',
    label: 'Employee Benefits',
    className: 'Employee',
    content: (
      <>
        <label>No recruitment fees</label>
        <p>
          Joblio is FREE for job seekers, because no one should have to pay to
          find a job.
        </p>

        <label>Access to meaningful jobs</label>
        <p>
          With transparent salaries, benefits and opportunities for professional
          growth – allowing job seekers to make decisions based on the
          information received directly from employers.
        </p>

        <label>Legal assistance</label>
        <p>With requisite immigration and working documentation.</p>

        <label>24/7 hotline</label>
        <p>
          Access to Joblio’s Applicant Concierge Experience (ACE) program –
          irrespective of skillset or national origin – for ongoing support with
          housing, transportation, banking, education and more.
        </p>

        <label>Cultural connection</label>
        <p>
          An opportunity to connect with communities of similar origin cultures.
        </p>
      </>
    )
  },
  {
    key: '3',
    label: 'Origination Country Benefits',
    className: 'Origination',
    content: (
      <>
        <label>No middlemen</label>
        <p>
          Joblio eliminates the need for all employment agents or labor brokers
          who may charge job applicants fees or who may misrepresent employment
          opportunities in other countries.
        </p>

        <label>Transparency and compliance</label>
        <p>Throughout the complete legal process.</p>

        <label>Foreign remittances</label>
        <p>
          An increase in the transferring of money from a foreign worker back to
          their home country due to an increase in worker stability and
          compensation.
        </p>
      </>
    )
  },
  {
    key: '4',
    label: 'Destination Country Benefits',
    className: 'Destination',
    content: (
      <>
        <label>Improved transparency</label>
        <p>
          Joblio’s model creates a centralized tracking system of work-related
          migration.
        </p>

        <label>Economic boost</label>
        <p>
          Due to increased tax revenues and optimized labor processes, plus the
          potential for new businesses.
        </p>

        <label>Cultural diversity</label>
        <p>
          Through Joblio’s effective human capital management solutions, the
          welcoming of diverse individuals improves standards of ESG
          (environmental, social and governance) and DEI (diversity, equity and
          inclusion).
        </p>
      </>
    )
  }
];

export default list;
